const emptyMap = new Map<unknown, unknown>()

/**
 * Retorna um Map vazio imutável com tipagem. Exemplo:
 *
 * ```ts
 * const myMap = someMap ?? emptyMapOf<MapKey, MapValue>();
 * ```
 */
export const emptyMapOf = <T, U>(): ReadonlyMap<T, U> => emptyMap as Map<T, U>
